import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';

const CustomTextFieldLabel = ({ text, optional = false, i18n }) => {
  const message = i18n.language === 'en' ? 'Optional' : 'اختياري';
  return (
    <span className={clsx('ctf-label', (text?.length > 0 || optional) && 'ctf-label-not-empty')}>
      {text}
      {optional && <span className="ctf-label-opt"> ({message})</span>}
    </span>
  );
};

CustomTextFieldLabel.propTypes = {
  text: PropTypes.string.isRequired,
  optional: PropTypes.bool,
};

export default withTranslation()(CustomTextFieldLabel);
